import { OrderByType, SettingsType } from '@nts/std/types';
import { ColumnInfo } from '../column-info';
import { ZoomColumnInfoInterface } from '@nts/std/interfaces';

export class ZoomColumnInfo extends ColumnInfo implements ZoomColumnInfoInterface {

    orderIndex: number;
    orderByIndex?: number;
    orderBy?: OrderByType;

    constructor(propertyName: string, orderIndex: number) {
        super(propertyName);
        this.settings = SettingsType.Default;
        this.orderIndex = orderIndex;
    }

    override resourceName(): string {

        if (this.settings === SettingsType.PropertyType) {
            return this.propertyTypeName;
        }

        // TODO: Verificare il toString()
        return this.settings.toString();
    }
}

